import { AccountBalanceWallet } from "@mui/icons-material"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material"
import { useActiveAddress } from "arweave-wallet-kit"
import React from "react"
import { Link } from "react-router-dom"

export function PortfolioAgentOnboarding() {
  const KEY = "portfolio-agent-onboarding"
  const [firstTime, setFirstTime] = React.useState(localStorage.getItem(KEY) !== "false")

  const handleClick = () => {
    setFirstTime(false)
    localStorage.setItem(KEY, "false")
  }

  const activeAddress = useActiveAddress()

  return (
    <>
      {firstTime && activeAddress && (
        <Dialog fullWidth maxWidth="xs" open={true}>
          <DialogTitle sx={{ textAlign: "center" }}>
            <Typography variant="subtitle1" fontWeight={700} color="primary">
              Try Portfolio Agents
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ textAlign: "center" }}>
            <Typography variant="caption">
              Thank you for connecting!
              <br />
              Go to 'My Portfolio' to start your first portfolio agent.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleClick}
              variant="outlined"
              color="accent"
              component={Link}
              to={`/entity/${activeAddress}`}
              startIcon={<AccountBalanceWallet />}
              sx={{ textTransform: "none" }}
            >
              My Portfolio
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  )
}
